import axios from "axios";
import { API_HOST } from "@/core/variables";
import { ScenarioUpdate } from "@/model";


class ScenarioRepository {
    create = async (name: string, description: string) => {
        return axios
            .post(`${API_HOST}/scenario`, {
                name,
                description
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    findAll = async () => {
        return axios
            .get(`${API_HOST}/scenario`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    findPage = async (page?: number, size?: number, keyword?: string) => {
        return axios
            .get(`${API_HOST}/scenario/paginate`, {
                params: {
                    page: page,
                    size: size,
                    keyword: keyword
                }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    read = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    update = async (scenarioId: string, scenario: ScenarioUpdate) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}`, scenario)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    delete = async (scenarioId: string) => {
        return axios
            .delete(`${API_HOST}/scenario/${scenarioId}`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    export = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/export`, {
                responseType: "blob",
                headers: { "Cache-Control": "no-cache" }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    import = async (scenarioId: string, formData: FormData) => {
        return axios
            .post(`${API_HOST}/scenario/${scenarioId}/import`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 5 * 60 * 1000
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    getAutocompletes = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/autocomplete`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };
}

const scenarioRepository = new ScenarioRepository();

export default scenarioRepository;
